import React, { useState, useEffect } from "react";
import CollapseButton from "../../../utilities/CollapseButton/CollapseButton";
import { checkSectionValid } from "../../Page/TransactionSummaryPage/Shared/HelperFunctions";
import { accessToServiceTitleType } from "../../Page/TransactionSummaryPage/Shared/Constants";

const AccessToServices = ({
  data,
  context,
  accessToServices,
  currentSubscriber,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allAccessToServices, setAllAccessToServices] = useState(<div />);
  const [showComponent, setShowComponent] = useState(
    checkSectionValid(accessToServices),
  );

  useEffect(() => {
    if (accessToServices && currentSubscriber !== undefined) {
      if (currentSubscriber === undefined) {
        setAllAccessToServices(setDetails(accessToServices.groupService));
      } else {
        var accessToServicesBySubscriber = accessToServices.groupService.filter(
          (service) => service.subscriber === currentSubscriber,
        );
        setShowComponent(true);
        setAllAccessToServices(setDetails(accessToServicesBySubscriber));
        if (accessToServicesBySubscriber.length === 0) {
          setShowComponent(false);
        }
      }
    }
  }, [accessToServices, currentSubscriber]);

  const cardTitle =
    data.accessToServicesTopic.value === ""
      ? "טופס גישה לשירותים"
      : data.accessToServicesTopic.value;

  return showComponent ? (
    <div className="block-frame p-2">
      <CollapseButton
        cardTitle={cardTitle}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />
      {isOpen && (
        <div className="block-frame__container">{allAccessToServices}</div>
      )}
    </div>
  ) : null;
};
function setDetails(accessToServices) {
  return (
    <React.Fragment>
      <hr />
      {accessToServices.map((access, idx) => {
        return (
          <div
            className="access-to-services__list-info"
            key={idx.toString() + access.name}
          >
            <div className="block-frame__row block-frame__row--1">
              <div className="block-frame__status-holder">
                <span className="access-to-services__header-name">
                  {access.headerName}
                </span>
              </div>
              {access.allServices.map((service, idx) => {
                if (access.headerName != "") {
                  return (
                    <div className="access-to-services__column" key={idx}>
                      <label className="access-to-services__service-name">
                        {service.name}
                      </label>
                      <div className={"access-to-services__radio"}>
                        <input
                          type="radio"
                          className="access-to-services__radio-custom"
                          label={"פתוח"}
                          readOnly
                          checked={service.isAllow}
                          disabled={!service.isAllow}
                        />
                        <span
                          className={
                            service.isAllow
                              ? "access-to-services__text-allow"
                              : "access-to-services__text-disable"
                          }
                        >
                          פתוח
                        </span>
                      </div>
                      <div className={"access-to-services__radio"}>
                        <input
                          type="radio"
                          className="access-to-services__radio-custom"
                          label={"חסום"}
                          readOnly
                          checked={!service.isAllow}
                          disabled={service.isAllow}
                        />
                        <span
                          className={
                            !service.isAllow
                              ? "access-to-services__text-allow"
                              : "access-to-services__text-disable"
                          }
                        >
                          חסום
                        </span>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
}

export default AccessToServices;
